import { Fragment, useContext, useState } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import AuthContext from "../AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
const navigation = [
  { name: "Dashboard", href: "/", type: "All" },
  { name: "Training Centre", href: "/centre", type: "Superadmin" },
  { name: "User", href: "/users", type: "Superadmin" },
  { name: "Courses", href: "/courses", type: "All" },
  { name: "Batches", href: "/batches", type: "All" },
  { name: "Trainer", href: "/trainer", type: "All" },
  { name: "Scheme", href: "/scheme", type: "Superadmin" },
  { name: "Students", href: "/students", type: "All" },
  { name: "Sanction Order", href: "/sanction", type: "All" },
  { name: "Ledger", href: "/ledger", type: "All" },
  { name: "Invoice", href: "/invoice", type: "All" },
  {name:"Employee",href:'/employee',type:"HR"},
  {name:"Reports",href:'/reports',type:"All"}
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [isSignedOut, setIsSignedOut] = useState(false);

  const filteredNavigation = navigation.filter(item => {
    if (authContext.userType === "HR") {
      return item.type === "HR"; // Only show items for HR
    } 
    else if(authContext.userType==='Trainer'){
      return item.name ==="Batches"
    }
    else if(authContext.userType==='Accounts'){
      return item.name ==="Ledger" || item.name ==="Invoice" ||item.name==='Dashboard'||item.name==="Batches"||item.name==="Training Centre" ||item.name==="Reports"
    }
    else if(authContext.userType === 'Manager') {
      return item.name !== "Invoice" && item.name !== "Ledger" && item.name !== "Employee";
    } else if(authContext.userType === 'Admin') {
      return item.name !== "Invoice" && item.name !== "Ledger" && item.name !== "Employee" && item.name!=="Scheme" && item.name!=="Training Centre" && item.name!=="User" &&item.name!=="Reports";
    }
    else if(authContext.userType==='Superadmin'){
      return item.type==='All'||item.type==='Superadmin'||item.type==='HR'
    }
    return item.type === "All" || item.type === authContext.userType;
  });

  const userNavigation = authContext.userType === "Admin" ? [
    { name: "View Profile", href: "/centre/details" },
    { name: "Sign out", href: "/login" },
  ] : [
    { name: "Sign out", href: "/login" },
  ];

  const handleSignOut = () => {
    setIsSignedOut(!isSignedOut);
    authContext.signout();
    navigate("/login");
  };

  const handleViewProfile = () => {
    navigate("/centre/details");
  };

  return (
    <div className="min-h-full">
      <Disclosure as="nav" className="bg-gray-800">
        {({ open }) => (
          <>
            <div className="max-w-8xl  md:px-0">
              <div className="flex h-16 items-center justify-between">
                {/* Logo and Name on the Left */}
                <div className="flex items-center">
                  <img
                    className="h-12 w-16 "
                    src={require("../assets/logo.png")}
                    alt="TRULY LOGO"
                  />
                  <span className="font-semibold  text-white text-md text-wrap italic">
                    Truly Yours Welfare Society
                  </span>
                </div>


                {/* Avatar and Menu Button on the Right */}
                <div className="flex items-center">
                  <div className="hidden md:block sm:block">
                    <div className="ml-4 flex items-center md:ml-6">
                      <Menu as="div" className="relative ml-3">
                        <div>
                          <Menu.Button className="flex max-w-xs items-center cursor-pointer bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <span className="sr-only">Open user menu</span>
                            <p className="text-md text-slate-50 bg-slate-700 py-1 shadow-md px-4 text-justify rounded-sm hover:bg-slate-900">
                              {authContext.username}
                            </p>
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {userNavigation.map((item) => (
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <span
                                    onClick={item.name === "Sign out" ? handleSignOut : handleViewProfile}
                                    className={classNames(
                                      active ? "bg-gray-100" : "",
                                      "block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                                    )}
                                  >
                                    {item.name}
                                  </span>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      <Avatar username={authContext.userType} isSignedOut={isSignedOut} userid={authContext.user} />
                    </div>
                  </div>
                  <div className=" flex md:hidden">
                    <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="md:hidden">
              <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                {filteredNavigation.map((item) => (
                  <Link to={item.href} key={item.name}>
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      className={classNames(
                        item.current
                          ? "bg-gray-900 text-white"
                          : "text-gray-300 hover:bg-gray-700 hover:text-white",
                        "block rounded-md px-3 py-2 text-base font-medium"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  </Link>
                ))}
              </div>
              <div className="border-t border-gray-700 pt-4 pb-3">
                <div className="flex items-center px-5">
                  <div className="flex-shrink-0"></div>
                  <div className="ml-3">
                    <div className="text-base font-medium leading-none text-slate-50 bg-slate-700 rounded-sm shadow-md px-4 py-2">
                      {authContext.username}
                    </div>
                  </div>
                </div>
                <div className="mt-3 space-y-1 px-2">
                  {userNavigation.map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as="span"
                      onClick={item.name === "Sign out" ? handleSignOut : handleViewProfile}
                      className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white cursor-pointer"
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
